import Splide from '@splidejs/splide';

export default function galleryCarousel() {

    // console.log('Gallery Carousel initialized');

    const carousels = document.querySelectorAll('.gallery-carousel');

    carousels.forEach(carousel => {
        const splideGallery = carousel.querySelector('.gallery-carousel .splide');
        if (splideGallery) {
            const gallery = new Splide(splideGallery, {
                pagination: false,
                arrows: false,
                drag: true,
                perPage: 1,
                perMove: 1,
                type: 'fade',
                rewind: true,
            });

            gallery.mount();
        }
    });

}